import morrisonsLogo from '../assets/images/morrisons.png';
import sainsburysLogo from '../assets/images/sainsburys.png';
import waitroseLogo from '../assets/images/waitrose.png';
import tescoLogo from '../assets/images/tesco.png';
import amazonLogo from '../assets/images/amazon.png';

import casualLife1 from '../assets/images/casual-life-1.png';
import casualLife2 from '../assets/images/casual-life-2.png';
import casualLife3 from '../assets/images/casual-life-3.png';
import casualLife4 from '../assets/images/casual-life-4.png';

import looseWeightImage from '../assets/images/loose-weight.png';
import balanceMenuImage from '../assets/images/balance-menu.png';
import gainWeightImage from '../assets/images/gain-weight.png';

export const questionarySteps = [
  {
    field: 'sweet_drinks',
    step: 16,
  },
  {
    field: 'meals_per_day',
    step: 15,
  },
  {
    field: 'preparations_in_advance',
    step: 14,
  },
  {
    field: 'share_meals',
    step: 13,
  },
  {
    field: 'chronic_diseases',
    step: 12,
  },
  {
    field: 'days',
    step: 11,
  },
  {
    field: 'goal',
    step: 10,
  },
  {
    field: 'disliked_products',
    step: 9,
  },
  {
    field: 'allergies',
    step: 8,
  },
  {
    field: 'excluded_meals',
    step: 7,
  },
  {
    field: 'physical_activity',
    step: 6,
  },
  {
    field: 'height',
    step: 5,
  },
  {
    field: 'weight',
    step: 4,
  },
  {
    field: 'birth_date',
    step: 3,
  },
  {
    field: 'gender',
    step: 2,
  },
];

export const unitTypeLabels = {
  without_amount: '',
  amount: '',
  gram: 'gram',
  cup: 'cups',
  tablespoon: 'table spoon',
  teaspoon: 'tea spoon',
};

export const mealNames = [
  'breakfast',
  'snack',
  'lunch',
  'dinner',
];

export const MORRISONS_LINK = 'morrisons';
export const SAINSBURYS_LINK = 'sainsburys';
export const WAITROSE_LINK = 'waitrose';
export const TESCO_LINK = 'tesco';
export const AMAZON_LINK = 'amazon';

export const shopsData = [
  {
    link: MORRISONS_LINK,
    logo: morrisonsLogo,
    active: true,
  },
  {
    link: SAINSBURYS_LINK,
    logo: sainsburysLogo,
  },
  {
    link: WAITROSE_LINK,
    logo: waitroseLogo,
  },
  {
    link: TESCO_LINK,
    logo: tescoLogo,
  },
  {
    link: AMAZON_LINK,
    logo: amazonLogo,
  },
];

export const KILOGRAM = 'kg';
export const POUND = 'lb';
export const STONES = 'st';

export const weightLabel = {
  [KILOGRAM]: 'kg',
  [POUND]: 'pounds',
  [STONES]: 'stones',
};

export const howActiveItems = [
  {
    image: casualLife1,
    value: 'passive',
    label: 'Sedentary',
  },
  {
    image: casualLife2,
    value: 'moderate',
    label: 'Exercise 1-3 times per week',
  },
  {
    image: casualLife3,
    value: 'highly',
    label: 'Exercise 4-5 times per week',
  },
  {
    image: casualLife4,
    value: 'sportsmen',
    label: 'Professional sportsman',
  },
];

export const physicalActivityLabels = howActiveItems.reduce((activityLabels, item) => {
  activityLabels[item.value] = item.label;
  return activityLabels;
});

export const goalItems = [
  {
    image: looseWeightImage,
    value: 'loose',
    label: 'Lose weight',
  },
  {
    image: balanceMenuImage,
    value: 'balanced',
    label: 'Balanced my diet',
  },
  {
    image: gainWeightImage,
    value: 'gain',
    label: 'Gain weight',
  },
];

export const goalLabels = goalItems.reduce((goalLabels, item) => {
  goalLabels[item.value] = item.label;
  return goalLabels;
}, {});